<div style="display: flex; flex-flow: column; justify-content: center; margin: 25px; padding-bottom: 25px; align-items: center;">

  <mat-spinner diameter="70"></mat-spinner>
  @if (message) {
    <p style="margin-left: 15px;">{{message}}</p>
  }

</div>
